import React from 'react'
import { Link } from 'gatsby'

import { Layout, Header, SectionTitle, Intro } from '../../../../components'

import data from './data.json'

import './style.scss'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        complete={true}
      >
        <Intro>
          <p>
            Typography guides a user through an experience by creating hierarchy
            and organizing information within the design. Refer to the{' '}
            <Link
              className="link"
              to={'/' + data.site + '/components/title/design'}
            >
              title
            </Link>
            ,{' '}
            <Link
              className="link"
              to={'/' + data.site + '/components/title/design'}
            >
              text content
            </Link>{' '}
            and relevant components for proper usage.
          </p>
          <p>
            Wilmington Trust uses <strong>Gotham ScreenSmart</strong> as the
            primary typeface for its visual language.
          </p>
        </Intro>
        <SectionTitle>Font Family</SectionTitle>
        <div class="fonts">
          <div class="default-font">
            <div class="font-preview">Gotham ScreenSmart</div>
            <div class="font-caption">Default Font</div>
          </div>
          <div class="other-fonts__container">
            <div class="other-fonts">
              <div class="font-preview u-type--weight-400">Aa</div>
              <div class="font-caption">
                <strong>Book</strong> 400
              </div>
            </div>
            <div class="other-fonts">
              <div class="font-preview">Aa</div>
              <div class="font-caption">
                <strong>Medium</strong> 500
              </div>
            </div>
            <div class="other-fonts">
              <div class="font-preview">Aa</div>
              <div class="font-caption">
                <strong>Bold</strong> 700
              </div>
            </div>
          </div>
        </div>
        <table class="table">
          <thead>
            <th>Style</th>
            <th>Weight</th>
            <th>Font Values</th>
            <th>Color</th>
            <th>Color Variable</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="c-title-1--normal">Title1</div>
              </td>
              <td> Book </td>
              <td>
                <div class="typography__font-values">
                  Font-size: <span class="value">32px</span> <br /> Line-height:
                  <span class="value">40px</span> <br /> Letter-spacing:
                  <span class="value">-2px</span>
                </div>
              </td>
              <td> #425968 </td>
              <td>$colorPrimaryBase</td>
            </tr>
            <tr>
              <td>
                <div class="c-title-2--normal">Title2</div>
              </td>
              <td>Book </td>
              <td>
                <div class="typography__font-values">
                  Font-size: <span class="value">24px</span> <br /> Line-height:
                  <span class="value">30px</span> <br /> Letter-spacing:
                  <span class="value">-1.5px</span>
                </div>
              </td>
              <td> #425968 </td>
              <td>$colorPrimaryBase</td>
            </tr>
            <tr>
              <td>
                <div class="c-title-3--normal">Title3</div>
              </td>
              <td>Book </td>
              <td>
                <div class="typography__font-values">
                  Font-size: <span class="value">18px</span> <br /> Line-height:
                  <span class="value">24px</span> <br /> Letter-spacing:
                  <span class="value">-1px</span>
                </div>
              </td>
              <td> #425968 </td>
              <td>$colorPrimaryBase</td>
            </tr>
            <tr>
              <td>
                <div class="c-title-4--normal">Title4</div>
              </td>
              <td>Bold </td>
              <td>
                <div class="typography__font-values">
                  Font-size: <span class="value">14px</span> <br /> Line-height:
                  <span class="value">20px</span>
                </div>
              </td>
              <td> #425968 </td>
              <td>$colorPrimaryBase</td>
            </tr>
            <tr>
              <td>
                <div class="c-text-content-lead--normal">LeadParagraph</div>
              </td>
              <td>Book </td>
              <td>
                <div class="typography__font-values">
                  Font-size: <span class="value">18px</span> <br /> Line-height:
                  <span class="value">30px</span>
                </div>
              </td>
              <td> #010000 </td>
              <td>$colorGrayscaleBlack</td>
            </tr>
            <tr>
              <td>
                <div class="c-text-content-body--normal">Body</div>
              </td>
              <td> Book </td>
              <td>
                <div class="typography__font-values">
                  Font-size: <span class="value">16px</span> <br /> Line-height:
                  <span class="value">24px</span>
                </div>
              </td>
              <td> #010000 </td>
              <td>$colorGrayscaleBlack</td>
            </tr>
            <tr>
              <td>
                <div class="c-text-content-caption--normal">Caption</div>
              </td>
              <td>Book</td>
              <td>
                <div class="typography__font-values">
                  Font-size: <span class="value">12px</span> <br /> Line-height:
                  <span class="value">18px</span>
                </div>
              </td>
              <td> #636363 </td>
              <td>$colorGrayscaleGrayDark</td>
            </tr>
          </tbody>
        </table>
      </Layout>
    </>
  )
}
